import { AppConfig } from 'config';
import crudProvider from 'ra-data-nestjsx-crud';
import { fetchUtils } from 'react-admin';

const httpClient = (url: string, options: any = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  const parsedUrl = url
    // remove indexes of filter and sort parameters from url string
    .replace(/(%5B\d+%5D)/g, '')
    //set filters case-insensitive
    .replace(/%7C%7C%24cont%7C%7C/g, '%7C%7C%24contL%7C%7C');
  const token = localStorage.getItem('token');
  options.headers.set('Authorization', `Bearer ${token}`);
  return fetchUtils.fetchJson(parsedUrl, options);
};

export const dataProvider = {
  ...crudProvider(AppConfig.API_URL, httpClient),
};
